import { render, staticRenderFns } from "./ThirdStep.vue?vue&type=template&id=2b8343d4&scoped=true"
import script from "./ThirdStep.vue?vue&type=script&lang=js"
export * from "./ThirdStep.vue?vue&type=script&lang=js"
import style0 from "./ThirdStep.vue?vue&type=style&index=0&id=2b8343d4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8343d4",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Providers/wizard/ThirdStep.vue
// module id = 2509
// module chunks = 31